import { Link, VARIATION_NAMES } from './Header';

export enum LinkIdentifier {
  LOGIN = 'login',
  LOGOUT = 'logout',
}

export interface DefaultLink extends Link {
  identifier?: LinkIdentifier;
}

export interface DefaultMenuLinkOptions {
  deConsumer?: boolean;
  subpath?: string;
  primaryDomain?: string;
  switchLocaleLink?: string;
  hideLoginLink?: boolean;
  hideLogoutLink?: boolean;
  hideLanguageSwitch?: boolean;
  customLinksPassedIn?: boolean;
  loginLinkClassName?: string;
  languageLinkClassName?: string;
}

export interface DefaultMenuLinksObject {
  [VARIATION_NAMES.LOGGED_OUT]: Array<Link | DefaultLink>;
  [VARIATION_NAMES.LOGGED_IN]: Array<Link | DefaultLink>;
}

/**
 * Default menu links for each header variation.
 * Apps can import this method into their app if they need to
 * extend the existing default list of menu links.
 */
export function defaultMenuLinks(options: DefaultMenuLinkOptions = {}): DefaultMenuLinksObject {
  const { deConsumer, primaryDomain = '', hideLoginLink, hideLogoutLink, loginLinkClassName } = options;

  // NOTE: order matters here and links will be displayed in order added to the arrays
  const loggedOut: Array<Link | DefaultLink> = [];
  const loggedIn: Array<Link | DefaultLink> = [];

  if (!hideLoginLink) {
    loggedOut.push({
      className: loginLinkClassName,
      href: deConsumer ? `${primaryDomain}/login?check_de=1` : `${primaryDomain}/login`,
      identifier: LinkIdentifier.LOGIN,
      label: 'Login',
    });
  }

  if (!hideLogoutLink) {
    loggedIn.push({
      href: `${primaryDomain || ''}/logout`,
      identifier: LinkIdentifier.LOGOUT,
      label: 'Logout',
    });
  }

  const links: DefaultMenuLinksObject = {
    [VARIATION_NAMES.LOGGED_OUT]: loggedOut,
    [VARIATION_NAMES.LOGGED_IN]: loggedIn,
  };

  return links;
}

export default defaultMenuLinks;
